function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icn_circle_arrow");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "99.4562922%",
  y2: "50%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6AB53",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3BF74",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.0867941,13.804349 C17.0867941,13.9277101 17.0497745,14.0509584 16.9819428,14.1433946 L13.9000583,18.7663343 C13.7891122,18.9328098 13.6041269,19.0437558 13.3884424,19.0437558 L11.5392666,19.0437558 C11.2002209,19.0437558 10.9227994,18.7663343 10.9227994,18.4272886 C10.9227994,18.3040403 10.959819,18.180792 11.0276507,18.0883558 L13.8815485,13.804349 L11.0276507,9.520455 C10.959819,9.4280188 10.9227994,9.30477048 10.9227994,9.18140933 C10.9227994,8.84247652 11.2002209,8.56505501 11.5392666,8.56505501 L13.3884424,8.56505501 C13.6041269,8.56505501 13.7891122,8.67600105 13.9000583,8.84247652 L16.9819428,13.4654162 C17.0497745,13.5578524 17.0867941,13.6811007 17.0867941,13.804349 Z",
  id: "path-2"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "preview-card-mobile",
  transform: "translate(-369.000000, -794.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(369.000000, 280.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-20",
  transform: "translate(0.000000, 514.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icn_circle_arrow",
  transform: "translate(-0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "base",
  fill: "url(#linearGradient-1)",
  transform: "translate(14.000000, 14.000000) rotate(-270.000000) translate(-14.000000, -14.000000) ",
  cx: 14,
  cy: 14,
  r: 14
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("use", {
  id: "icn_arrow_up",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  transform: "translate(14.004797, 13.804405) rotate(-360.000000) translate(-14.004797, -13.804405) ",
  xlinkHref: "#path-2"
}))))));

var SvgIcnCircleArrow = function SvgIcnCircleArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCircleArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_circle_arrow.3888b7d1.svg";
export { ForwardRef as ReactComponent };